// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { operatorId } from './Operator';
import { z } from 'zod';
export const emailLogId = (z.number());
export const emailLog = z.object({
    id: emailLogId,
    recipient: z.string(),
    subject: z.string(),
    template: z.string(),
    status: z.string(),
    error: z.string().nullable(),
    operator_id: operatorId.nullable(),
    metadata: z.unknown().nullable(),
    sent_at: z.date().nullable(),
    created_at: z.date(),
});
export const emailLogInitializer = z.object({
    id: emailLogId.optional(),
    recipient: z.string(),
    subject: z.string(),
    template: z.string(),
    status: z.string().optional(),
    error: z.string().optional().nullable(),
    operator_id: operatorId.optional().nullable(),
    metadata: z.unknown().optional().nullable(),
    sent_at: z.date().optional().nullable(),
    created_at: z.date().optional(),
});
export const emailLogMutator = z.object({
    id: emailLogId.optional(),
    recipient: z.string().optional(),
    subject: z.string().optional(),
    template: z.string().optional(),
    status: z.string().optional(),
    error: z.string().optional().nullable(),
    operator_id: operatorId.optional().nullable(),
    metadata: z.unknown().optional().nullable(),
    sent_at: z.date().optional().nullable(),
    created_at: z.date().optional(),
});
//# sourceMappingURL=EmailLog.js.map